import { PropsWithClassName } from "@models/types/index";
import classNames from "classnames";
interface Props extends PropsWithClassName {
  path: string;
  content?: React.ReactNode;
  name?: string;
  alt: string;
  toneless?: boolean;
}

export function BannerPage({
  path,
  name,
  alt,
  className,
  toneless,
  content,
}: Props) {
  return (
    <div
      className={classNames(`relative`, {
        "h-[250px]": !className,
        [`${className}`]: className,
      })}
    >
      <img src={path} className="object-cover h-full w-full" alt={alt} />
      {toneless && <div className="absolute inset-0 bg-black opacity-50"></div>}
      <div className="absolute inset-0 flex items-center flex-col justify-center text-white font-chivo-black-italic text-center text-[55px] lg:text-left lg:text-[110px]">
        <div className="w-[292px] flex flex-col items-center lg:w-full">
          {name && (
            <>
              <h1>{name}</h1>
              <div className="flex items-center text-[28px] justify-center bg-white h-[2px] w-36" />
              {content && <div id="content-banner">{content}</div>}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
